import React, { useEffect, useState } from "react";
import {
    Row,
    Col,
    FormGroup,
    Label,
    Input,
    Container,
    FormFeedback,
    Form,
    Button,
} from "reactstrap";
import { Formik } from "formik";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { useNavigate, useParams } from "react-router-dom";
import ResultHandler from "../../../components/ResultHandler";
import FormButtonHandler from "../../../components/FormButtonHandler";
import { useResponse } from "../../../hooks/useResponse";
import { useTranslation } from "react-i18next";
import { getFeedback, editFeedback } from "../../../api/feedback";
const validateFeedback = (values) => {
    const errors = {};
    if (values.clientSatisfaction && values.clientSatisfaction.length > 200) {
        errors.clientSatisfaction = "Too long";
    }
    if (values.notes && values.notes.length > 500) {
        errors.notes = "Too long";
    }
    return errors;
};

const EditFeedback = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { id } = useParams();
    const dealId = localStorage.getItem("dealIdfeedback");
    console.log("dealIddealIddealId", dealId);
    const [initialValues, setInitialValues] = useState({
        clientSatisfaction: "",
        campaignDelivered: false,
        upsellPotential: false,
        notes: "",
    });

    const { setData, loading, error, success } = useResponse(editFeedback, () => {
        navigate(`/deals/show/${dealId}`);
    });

    useEffect(() => {
        const fetchFeedback = async () => {
            try {
                const res = await getFeedback(id);
                const data = res?.data;

                setInitialValues({
                    clientSatisfaction: data?.clientSatisfaction || "",
                    campaignDelivered: data?.campaignDelivered ?? false,
                    upsellPotential: data?.upsellPotential ?? false,
                    notes: data?.notes || "",
                });
            } catch (err) {
                console.error("Failed to fetch feedback", err);
            }
        };

        fetchFeedback();
    }, [id]);

    return (
        <div className="page-content">
            <Container fluid={true}>
                <Breadcrumbs title={`${t("btns.Edit")} ${t("Feedback")}`} />

                <Formik
                    enableReinitialize
                    initialValues={initialValues}
                    validate={validateFeedback}
                    onSubmit={(values) => {
                        setData({
                            id,
                            data: values,
                            type: "edit",
                        });
                    }}
                >
                    {(formik) => (
                        <Form
                            className="needs-validation"
                            onSubmit={(e) => {
                                e.preventDefault();
                                formik.handleSubmit();
                            }}
                        >
                            <Row className="mb-3">
                                <Col md="6">
                                    <FormGroup>
                                        <Label>{t("Client Satisfaction")}</Label>
                                        <Input
                                            type="text"
                                            name="clientSatisfaction"
                                            placeholder={t("Enter client satisfaction")}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.clientSatisfaction}
                                            invalid={
                                                !!(
                                                    formik.touched.clientSatisfaction &&
                                                    formik.errors.clientSatisfaction
                                                )
                                            }
                                        />
                                        <FormFeedback>
                                            {formik.errors.clientSatisfaction}
                                        </FormFeedback>
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row>
                                <Col md="6">
                                    <FormGroup check>
                                        <Input
                                            type="checkbox"
                                            name="campaignDelivered"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            checked={formik.values.campaignDelivered}
                                        />
                                        <Label check className="mb-0 ms-2">{t("Campaign Delivered")}</Label>
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup check>
                                        <Input
                                            type="checkbox"
                                            name="upsellPotential"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            checked={formik.values.upsellPotential}
                                        />
                                        <Label check className="mb-0 ms-2">{t("Upsell Potential")}</Label>
                                    </FormGroup>
                                </Col>
                            </Row>

                            <FormGroup className="mb-3 mt-3">
                                <Label>{t("Notes")}</Label>
                                <Input
                                    type="textarea"
                                    name="notes"
                                    placeholder={t("Enter notes")}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.notes}
                                    invalid={!!(formik.touched.notes && formik.errors.notes)}
                                />
                                <FormFeedback>{formik.errors.notes}</FormFeedback>
                            </FormGroup>

                            <FormButtonHandler btnTxt={t("Update")} loading={loading} />

                            <ResultHandler
                                error={error}
                                success={success}
                                successMsg={t("Updated Successfully!")}
                            />
                        </Form>
                    )}
                </Formik>
            </Container>
        </div>
    );
};

export default EditFeedback;
